await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false); 
await loadComponent('./res/mc-events.js', false); 

class CartNotification extends McElement {

  connectedCallback() {
    console.log('CartNotification: connected');
    window.addEventListener(MCEVENTS.CART_ADDED, this.onCartUpdated.bind(this));
  }
  
  onCartUpdated = (e) => {
    const item = e.detail?.items ? e.detail.items[0] : e.detail;
    if(!item?.handle){
      console.warn('CartNotification: no handle in event detail');
      return;
    }

    const modal = bootstrap.Modal.getOrCreateInstance(this);
    if(!modal) {
      console.warn('CartNotification: modal not found');
      return;
    }

    modal.show();
    this.render(item);
  }

  render = (item) => {
    const body = this.querySelector('[data-body]');
    if(!body) {
      console.warn('CartNotification: body not found');
      return;
    }

    McShopify.section({
      path: `${Shopify.routes.root}products/${item.handle}`,
      section_id: `helper-cart-notification`,
      onSuccess: data => {
        body.innerHTML = data.replaceAll('{variant}', item.options_with_values[0].value);
      }
    });
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}

window.CartNotification = CartNotification;